// @flow
import { useEffect } from 'react';

// IE11 specifically doesn't support passive and has "useCapture: boolean" instead
let isPassiveSupported = false;

try {
  const options = {
    get passive() {
      // This function will be called when the browser
      //   attempts to access the passive property.
      isPassiveSupported = true;
      return false;
    }
  };

  window.addEventListener('test', null, options);
  window.removeEventListener('test', null, options);
} catch (err) {
  isPassiveSupported = false;
}

export default function useOnScroll(
  handler: Function,
  watchers?: any[],
  useOnResize?: boolean
) {
  useEffect(() => {
    const options = isPassiveSupported ? { passive: true } : false;
    window.addEventListener('scroll', handler, options);
    window.addEventListener('touchmove', handler, options);
    if (useOnResize) {
      window.addEventListener('resize', handler, options);
    }
    return () => {
      window.removeEventListener('scroll', handler);
      window.removeEventListener('touchmove', handler);
      window.removeEventListener('resize', handler);
    };
  }, watchers);
}
